import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function AboutBanner() {
  const { t } = useTranslation();

  return (
    <section className="relative h-72 md:h-96 flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20pet%20product%20company%20office%20interior%2C%20warm%20wooden%20furniture%2C%20natural%20light%2C%20plants%2C%20minimalist%20Scandinavian%20design%2C%20cozy%20workspace%2C%20warm%20beige%20and%20brown%20tones%2C%20professional%20yet%20welcoming%20atmosphere&width=1440&height=500&seq=about-banner&orientation=landscape"
          alt="About Koorpet"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/45 to-black/20"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 w-full">
        <div className="flex items-center gap-2 text-white/60 text-xs mb-4">
          <Link to="/" className="hover:text-white transition-colors cursor-pointer">{t('about_breadcrumb_home')}</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-white/90">{t('about_breadcrumb_about')}</span>
        </div>
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-3 leading-tight">
          {t('about_banner_title')}
        </h1>
        <p className="text-white/70 text-sm md:text-base max-w-lg leading-relaxed">
          {t('about_banner_desc')}
        </p>
      </div>
    </section>
  );
}